<div class="recovery__page">
  <div class="main--wrapper">
    <!-- Start Header Section -->
    <header>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="auth-section--logo">
              <a role="button" [href]="commonService.landingUrl">
                <img [src]="commonService?.getOrgWindowObject?.LOGO_URL ? commonService?.getOrgWindowObject?.LOGO_URL : 'assets/images/logo.png'" 
                onerror="this.src='assets/images/logo.png';" alt="Logo">
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- End Header Section -->

    <!-- Start Reset Password Box Section -->
    <div class="container">
      <form autocomplete="new-password" *ngIf="isCodeValid" [formGroup]="recoveryForm" class="form">
        <div class="auth-box--wrapper position-relative">
          <div class="blueish-bg position-relative">
            <div class="shade upper"></div>
            <div class="shade lower"></div>
          </div>

          <div class="box-wrapper">
            <h3 class="auth-box--title"  [ngClass]="{'mb-0': resetDone}">
              {{resetDone ? 'New password set' : 'Reset password'}}
            </h3>
            <div class="bluish-background"></div>

            <ng-container *ngIf="resetDone; else passwordResetForm">
              <div class="color--gray font-size-12 mt-10 mb-50 text-center">
                Now you can log in to your account
              </div>
              <div class="text-center mb-55">
                <svg-icon name="password_reset"></svg-icon>
              </div>
              <div class="text-center">
                <button type="button" class="button primary__button large__button font-size-18 pl-5 pr-5"
                        (click)="backToLogin()">
                  Log in
                </button>
              </div>
            </ng-container>

            <ng-template #passwordResetForm>
              <!-- Choose Password -->
              <div class="form-group" [ngClass]="{'error-block': checkControlValid('USER_PASSWORD') || error}">
                <label class="font-size-20 mb-0">Enter your new password</label>
                <div class="font-size-12__imp mb-15 color--gray font-weight-normal">Password must be at least 8 characters with at least 1 number and 1 special character (&#64;, $, !, %, *, #, ?, &)</div>
                <div>
                  <input id="recovery-new-password" type="password" formControlName="USER_PASSWORD" class="input input__large input__blue"
                         placeholder="Choose Password" maxlength="50" autocomplete="new-password"
                         [ngClass]="{'error-input': checkControlValid('USER_PASSWORD')}" required />
                  <ng-container *ngIf="checkControlValid('USER_PASSWORD')">
                    <div class="error-text">Password must be at least 8 characters with at least 1 number and 1 special character (&#64;, $, !, %, *, #, ?, &)</div>
                  </ng-container>
                  <ng-container *ngIf="error">
                    <div class="error-text">{{error}}</div>
                  </ng-container>
                </div>
              </div>

              <!-- Confirm Password -->
              <div class="form-group" [ngClass]="{'error-block': checkControlValid('USER_CONFIRM_PASSWORD')}">
                <label class="font-size-20 mb-15">Confirm your new password</label>
                <div>
                  <input id="recovery-retype-password"  type="password" formControlName="USER_CONFIRM_PASSWORD"
                         class="input input__large input__blue" placeholder="Confirm Password" maxlength="50"
                         [ngClass]="{'error-input': checkControlValid('USER_CONFIRM_PASSWORD')}" required />
                  <ng-container *ngIf="checkControlValid('USER_CONFIRM_PASSWORD')">
                    <div class="error-text">Password did not match!</div>
                  </ng-container>
                </div>
              </div>

              <!-- Submit -->
              <div class="row mt-40">
                <div class="col-12 mx-auto text-right">
                  <button id="recovery-change-password" type="button"
                          class="button primary__button large__button font-size-18" (click)="onSubmit()">
                    Set new password
                  </button>
                </div>
              </div>
            </ng-template>
          </div>

        </div>
      </form>

      <!-- Code is Invalid -->
      <div *ngIf="!isCodeValid" class="alert alert-danger text-center">
        <strong>Invalid Code</strong> <br>
        You have used invalid or already expired reset code.
      </div>
    </div>
    <!-- End Reset Password Box Section -->

  </div>
</div>
